import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

/* The floor-grouped board. auto-fill at 86px is what keeps five hundred rooms
   legible on a supervisor's laptop and still usable on a tablet. */

export function FloorSection(
  { floor, count, children, className }:
  { floor: ReactNode; count?: ReactNode; children: ReactNode; className?: string },
) {
  return (
    <section className={cn('flex flex-col gap-2', className)}>
      <h3 className="flex items-center gap-2.5 text-[11.5px] font-semibold uppercase tracking-[0.04em] text-muted-fg">
        {floor}
        {count !== undefined && <span className="tnum font-normal opacity-80">{count}</span>}
        <span aria-hidden className="h-px grow bg-border" />
      </h3>
      {children}
    </section>
  )
}

export function RoomGrid({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <div className={cn('grid gap-2 [grid-template-columns:repeat(auto-fill,minmax(86px,1fr))]', className)}>
      {children}
    </div>
  )
}
